import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./pages/home";
import { GalleryPage } from "./pages/launch-gallery";
import { Nft } from "./pages/nft";

const apiUrl = 'https://mentoria-cursinho-production.up.railway.app/';

function App() {
  // useLogIp(apiUrl + 'observability/hello');
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/nft" element={<Nft />} />
      <Route path="/launch-gallery" element={<GalleryPage />} />
    </Routes>
  </BrowserRouter>
  );
}

export default App;
